import packageJson from '../../package.json';

// Import package json version
export const APP_VERSION = packageJson.version;
export const RELEASE_DATE = 'Oct 8, 2026';

export const changeLogs = [];
